// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("core.ruffle." + {"482":"ed609401890914fe729b","655":"bb89e2c71475661b0ba2"}[chunkId] + ".js");